module.exports = __webpack_public_path__ + "img/wlwps.04c00a7d.png";